import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit, half } = measures

const short = 16 * unit
const long = 36 * unit
const longMobile = 30 * unit
const superLong = 40 * unit

const control = ({ fluid, showError, underlined, strictSuperLong }) => {
  const bordered = !underlined
  const borderProp = underlined ? 'border-bottom' : 'border'
  const borderColor = showError ? colors.errors.error2 : colors.white40

  return css`
    color: ${showError ? colors.errors.error2 : colors.greens.green6};

    box-sizing: border-box;

    min-width: ${strictSuperLong ? superLong : short}px;
    ${fluid
      ? `
      width: 100%;
      max-width: 100%;
    `
      : `
      width: inherit;
      max-width: ${long}px;
    `}
    ${borderProp}: 1px solid ${borderColor};
    ${bordered && `border-radius: ${spacing(1.5)};`}

    outline: none;
    padding: ${spacing(2, 1.5)};
    transition: border-color 500ms, background-color 500ms;

    :disabled {
      cursor: not-allowed;
      background-color: ${colors.black10};
    }
  `
}

export const container = css`
  position: relative;
  width: inherit;
  min-height: ${8 * unit}px;
`

export const controlContainer = ({ fluid }) => css`
  display: inline-block;
  position: relative;
  width: 100%;
  ${!fluid && `max-width: ${long}px;`}
`

export const controlIconed = css`
  & > input {
    padding-right: ${4 * unit}px;
  }
`

export const icon = css`
  position: absolute;
  top: ${3 * half}px;
  right: ${unit}px;
  color: ${colors.white100};
`

export const label = ({ isRequired }) => {
  return css`
    position: absolute;
    z-index: 1;
    top: ${-half}px;
    left: ${2 * unit}px;
    color: ${colors.white40};
    background: ${colors.grays.gray8};
    padding-left: ${half}px;
    padding-right: ${half}px;
    ${isRequired &&
    `:after {
       content:"*";
       margin-left:${half}px;
      }`}
  `
}

export const select = (params) => css`
  background-color: ${colors.white100}, ${control(params)};
  font-size: ${unit * 1.83}px;
`

export const input = (params) => css`
  padding: ${params.strictPadding ? unit + half : unit}px;
  ${control(params)}
  background:  transparent;
  padding: ${spacing(2, 1.5)};
  font-size: ${unit * 1.83}px;
  ::placeholder {
    color: ${colors.white40};
  }
`

export const strictShort = css`
  width: ${short}px;
`

export const strictLong = css`
  width: ${long}px;
  ${MQ.PHONES} {
    width: ${longMobile}px;
  }
`

export const strictSuperLong = css`
  width: ${superLong}px;
  ${MQ.PHONES} {
    width: ${longMobile}px;
  }
`

export const errorContainer = css`
  color: ${colors.errors.error2};

  bottom: ${6 * unit}px;

  width: inherit;
  max-width: ${long}px;
  ${MQ.PHONES} {
    max-width: ${longMobile}px;
  }

  :first-letter {
    text-transform: uppercase;
  }
`

export { short, long }
